import script from "./SentView.vue?vue&type=script&setup=true&lang=js"
export * from "./SentView.vue?vue&type=script&setup=true&lang=js"

import "./SentView.vue?vue&type=style&index=0&id=03327889&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03327889"]])

export default __exports__